import { render, staticRenderFns } from "./Form_Label.vue?vue&type=template&id=f525d46e&scoped=true&"
import script from "./Form_Label.vue?vue&type=script&lang=js&"
export * from "./Form_Label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f525d46e",
  null
  
)

export default component.exports